import {Injectable, OnDestroy} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/finally';
import {Http, RequestOptions, RequestOptionsArgs, Response, XHRBackend} from '@angular/http';
import {Cookie} from 'ng2-cookies/ng2-cookies';
import {LoaderService} from '../loader/loader.service';
import {environment} from '../../environments/environment';
import {EventService} from './event.service';
import {User} from './model/user';
import {Subscription} from 'rxjs/Rx';

declare var $: any;

@Injectable()
export class HttpService extends Http implements OnDestroy {
  private pendingRequests = 0;
  private currentUser: User = null;
  private subscription: Subscription;
  private actionTaken = false;
  // check session timeout every 10 mins
  private sessionTimeout = 10 * 60 * 1000;

  constructor(backend: XHRBackend,
              private loaderService: LoaderService,
              private eventService: EventService) {
    super(backend, new RequestOptions({withCredentials : true}));
      this.subscription = this.eventService.getMessage().subscribe((event) => {
          if (event.type === 'user') {
              this.currentUser = event.data;
          }
      });

      setInterval(() => {
          if (!this.actionTaken && this.currentUser && this.currentUser.isLoggedIn) {
              this.eventService.sendMessage({type: 'updateUser'});
          }
          this.actionTaken = false;
      }, this.sessionTimeout );
  }

  // request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
  //   return this.intercept(super.request(url, options));
  // }
  get(url: string, options?: RequestOptionsArgs): Observable<Response> {
      //TODO:[Rostislav] this doesn't work as expected
      // if parameter is not encoded getParameterByName may fail to extract value

    const ruid = this.getParameterByName('ruid', url);
    if (ruid) {
      url = this.replaceUrl(url, 'ruid', encodeURIComponent(ruid));
    }
    const sessionizedUrl: string = this.sessionizeUrl(url);
    return this.intercept(super.get(sessionizedUrl, options));
  }

  post(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {

    const ruid = this.getParameterByName('ruid', url);
    const fileName = this.getParameterByName('fileName', url);
    if (ruid) {
      url = this.replaceUrl(url, 'ruid', encodeURIComponent(ruid));
    }
    if (fileName) {
      url = this.replaceUrl(url, 'fileName', encodeURIComponent(fileName));
    }
    const sessionizedUrl: string = this.sessionizeUrl(url);
    return this.intercept(super.post(sessionizedUrl, body, options));
  }

  put(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {

    const sessionizedUrl: string = this.sessionizeUrl(url);
    return this.intercept(super.put(sessionizedUrl, body, options));
  }

  delete(url: string, options?: RequestOptionsArgs): Observable<Response> {

    const sessionizedUrl: string = this.sessionizeUrl(url);
    return this.intercept(super.delete(sessionizedUrl, options));
  }

  sessionizeUrl(url: string) {
    if (url.indexOf('/api/login') >= 0 || url.indexOf('/api/zoho') >= 0) {
      return url;
    }
    let sessionizedUrl = url;
    // Url rewrite with jessionid
    const jsessionCookie = Cookie.get('JSESSIONID');
    if (jsessionCookie) {
      const queryPosition = url.indexOf('?');
      const param = ';jsessionid=' + jsessionCookie;
      if (queryPosition < 0) {
        sessionizedUrl += param;
      } else {
        sessionizedUrl = [url.slice(0, queryPosition), param, url.slice(queryPosition)].join('');
      }
    }
    return sessionizedUrl;
  }

  getParameterByName(name, url) {
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2]);
  }

  replaceUrl(url, param, value) {
    const re = new RegExp('[\\?&]' + param + '=([^&#]*)'), match = re.exec(url);
    let delimiter, newString;

    if (match !== null) {
      delimiter = match[0].charAt(0);
      newString = url.replace(re, delimiter + param + '=' + value);
    }

    return newString;
  }

  intercept(observable: Observable<Response>): Observable<Response> {
    const that = this;
    function updateAuth() {
        that.eventService.sendMessage({type: 'updateUser'});
    }

    this.actionTaken = true;
    this.onStart();
    return observable
      .do((res: Response) => {
        this.handlePayPalHeader(res.headers, updateAuth);
      }, (err: any) => {
        // console.log(err);
        if (err.status === 401 || err.status === 403) {
          if (!this.notAuthRequest(err.url) || (this.currentUser && this.currentUser.isLoggedIn)) {
              setTimeout(updateAuth, 1000);
          }
        }
        this.handlePayPalHeader(err.headers, updateAuth);
      })
      .finally(() => {
        this.onEnd();
      });
  }

    private handlePayPalHeader(headers: Headers, callback) {
        if (headers && headers.get('X-parser-ui-notification')) {
            // console.log('Notification header received.');
            setTimeout(callback, 1000);
        }
    }

    private notAuthRequest(url: string) {
      const servletPath = url
          .replace(environment.baseURL, '');
      const isAuthRequest = servletPath.startsWith('/api/auth') || servletPath.startsWith('/api/login');
      // console.log(`Is auth request : ${isAuthRequest}, for url : ${url}`);
      return isAuthRequest;
    }

    private onStart(): void {
        if (this.pendingRequests === 0) {
            this.showLoader();
        }
        this.pendingRequests++;
        // console.log('Pending reqs: ' + this.pendingRequests);
    }

    private onEnd(): void {
        this.pendingRequests--;
        if (this.pendingRequests === 0) {
            this.hideLoader();
        }
        // console.log('Pending reqs: ' + this.pendingRequests);
  }

  private showLoader(): void {
    this.loaderService.show();
  }

  private hideLoader(): void {
    this.loaderService.hide();
  }

  ngOnDestroy(): void {
      this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/services/interceptor.ts